import { defineLocalStore } from '@/utils/localStore'
import { useRoute, useRouter } from 'vue-router'
import { axios, useBreadcrumb } from '@/plugins'
import { computed, ref } from 'vue'
import { cachedObject } from 'best-modules/utils'
import {
  urlOrderSingle,
  urlOrderUpdateDocument,
  urlOrderUpdateExtraDocument,
  urlUpdateOrder,
} from '@/utils/urls'
import { cloneDeep } from 'lodash'
import { handleAsync, setSnackbar } from 'best-modules/plugins'
import { Order } from '@/utils/types/order'
import { File } from '@/utils/types/helpers'
import { useCan } from '@/composables/useCan'

export const { useLocalStore: useOrder, initLocalStore: initOrder } =
  defineLocalStore('order', () => {
    const route = useRoute()
    const router = useRouter()
    const breadcrumb = useBreadcrumb()
    const { can } = useCan()
    const orderId = computed<number>(() => {
      return Number(route.params.id)
    })
    const order = cachedObject<Order>({} as Order)
    const newFile = ref<File[] | null>(null)
    const disabled = computed<boolean>(() => {
      return !order.isActive || !can('protocols.update')
    })

    const getOrder = () => {
      return handleAsync('orderSingle', () => {
        return axios.get(urlOrderSingle(orderId.value)).then(res => {
          if (res.data.status === 403) {
            router.replace({ name: 'order-list-all' })
          } else {
            breadcrumb.set([{ title: res.data.name, index: 1 }])
            order.$set(res.data as Order)
          }
        })
      })
    }

    const orderUpdate = (o = null) => {
      return handleAsync('orderUpdate', () => {
        const req = cloneDeep(o || order.$object)
        req.document = newFile.value || req.document

        return axios.put(urlUpdateOrder(orderId.value), req).then(res => {
          order.$set(res.data)
          setSnackbar({ text: 'Наказ оновлено' })
        })
      })
    }

    const orderUpdateDocument = () => {
      return handleAsync('orderUpdateDocument', () => {
        return axios
          .patch(urlOrderUpdateDocument(orderId.value), {
            document: newFile.value,
          })
          .then(res => {
            order.$set(res.data)
            setSnackbar({ text: 'Наказ оновлено' })
          })
      })
    }
    const orderUpdateExtraDocument = () => {
      return handleAsync('orderUpdateExtraDocument', () => {
        return axios
          .patch(urlOrderUpdateExtraDocument(orderId.value), {
            extraDocuments: order.extraDocuments,
          })
          .then(res => {
            order.$set(res.data)
            setSnackbar({ text: 'Наказ оновлено' })
          })
      })
    }

    const orderReset = () => {
      return order.$reset()
    }

    getOrder()

    return {
      orderId,
      order,
      newFile,
      disabled,
      orderUpdate,
      orderReset,
      orderUpdateExtraDocument,
      orderUpdateDocument,
    }
  })
